import {register} from '@shopify/theme-sections';

export default register('featured-product', {
  onLoad() {},
});
